import { Link } from 'react-router-dom';
import { categories } from '@/mocks/anime';

export default function CategorySection() {
  return (
    <section className="w-full py-10 md:py-14 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6 lg:px-8">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-3xl font-bold text-foreground-50 font-heading mb-2">
            动漫分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-400 max-w-lg mx-auto">
            按类型快速找到你喜欢的动漫内容，八大分类覆盖所有国产动漫类型
          </p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-3 md:gap-4">
          {categories.map((cat) => (
            <Link
              key={cat.slug}
              to={`/category/${cat.slug}`}
              className="group p-4 md:p-5 rounded-lg bg-background-100 hover:bg-background-200 border border-background-200/60 hover:border-primary-500/30 transition-all duration-200 cursor-pointer"
            >
              <div className="w-10 h-10 md:w-12 md:h-12 flex items-center justify-center rounded-lg bg-primary-500/10 text-primary-400 group-hover:bg-primary-500 group-hover:text-background-50 transition-all duration-200 mb-3">
                <i className={`${cat.icon} text-lg md:text-xl`}></i>
              </div>
              <h3 className="text-sm md:text-base font-semibold text-foreground-100 mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500 line-clamp-2 mb-2">
                {cat.description}
              </p>
              <span className="text-xs text-primary-400 font-medium">
                {cat.count}部作品
              </span>
            </Link>
          ))}
        </div>
      </div>
    </section>
  );
}